import React from "react";
import "./LabeledInputToggle.scss";
import { Box, Typography } from "@mui/material";
import { ReactComponent as ErrorIcon } from "../../assets/images/ralvie/error-icon.svg";

const LabeledInputToggle = ({
  label,
  placeholder,
  value,
  onChange,
  onPaste,
  checked,
  onToggle,
  showPerUser = false,
  code,
  ...props
}) => {
  return (
    <div>
      <div className="labeled-input-toggle">
        <span className="label-box">{label}{props.required && <span style={{color:"#FE5050"}}>*</span>}</span>

          <div className="input-container1">
            <input
            type="number"
              className="input-field"
              style={{
                borderBottom: (props.error !== undefined && props.error !== "") ? "1px solid #FE5050" : "1px solid #D9D9D9"
              }}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              disabled={!checked}
              onPaste={onPaste}
              onKeyDown={(e) => {
                if (e.key === "e" || e.key === "E") {
                  e.preventDefault();
                }
              }}
            />
            {showPerUser && <span className="per-user">Per user</span>}
            {(props.error !== undefined && props.error !== "") && (
            <Box display={"flex"} alignItems={"center"} pt={0.5} ml={3}>
              <Box item pr={0.5} mt={0.5} >
                {<ErrorIcon />}
              </Box>
              <Box display="flex" alignItems="center">
                <Typography id="tags-error-message" className="helper-text">{props.error}</Typography>
              </Box>
            </Box>
          )}
          </div>
         
        <label className="toggle-switch">
          {code !== "MEMBER_COUNT" && <>
            <input type="checkbox" checked={checked} onChange={onToggle} />
            <span className="slider"></span>
          </>}
        </label>
      </div>

    </div>

  );
};

export default LabeledInputToggle;
